export default __webpack_public_path__ + "static/media/LogotipoHygraWhite.8decc28a.svg";